export default "__VITE_ASSET__5O6n8p2N__";